export default __webpack_public_path__ + "static/media/video-streaming-platform.a5dc37c4.png";